import { createStore } from "redux";
import templateReducer from "./template.reducer";

const CAStore = createStore(
  templateReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

export default CAStore;
